import styled from 'styled-components';

const HeaderWrapper = styled.header`
  width: 100%;
`;

export default HeaderWrapper;
